import React, {  useState } from "react";
import { InboxOutlined } from "@ant-design/icons";
import { message, Upload, Button, theme } from "antd";
import pako from "pako";
import PropTypes from "prop-types";
import { endpoint_uploader_invoices } from "../services";

const { Dragger } = Upload;

const compressFile = async (file) => {
	return new Promise((resolve, reject) => {
		const reader = new FileReader();
		reader.onload = function (e) {
			try {
				const compressed = pako.gzip(new Uint8Array(e.target.result));
				const blob = new Blob([compressed], { type: "application/gzip" });
				resolve({
					compressedFile: new File([blob], file.name + ".gz", { type: "application/gzip" })
				});
			} catch (err) {
				reject(err);
			}
		};
		reader.onerror = (err) => reject(err);
		reader.readAsArrayBuffer(file);
	});
};

const printMessages = (results) => {
	for (const { status, message: messageToShow, filename } of results) {
		if(status === 200){
			message.success(`${filename}: ${messageToShow}`);
		} else {
			message.error(`${filename}: ${messageToShow}`);
		}
	}
};

const handleUpload = async (token, fileList, setFileList, setLoading) => {
	if (fileList.length === 0) {
		message.error("No files selected for upload");
		return;
	}

	setLoading(true);

	const uploadFiles = async (files) => {
		const formData = new FormData();
		for (const file of files) {
			const { compressedFile } = await compressFile(file.originFileObj);
			formData.append("files", compressedFile);
		}
		formData.append("token", token);

		try {
			const response = await fetch(endpoint_uploader_invoices, {
				method: "POST",
				body: formData,
			});
	
			const results = await response.json();
			if (response.ok) {
				printMessages(results);
			} else if(response.status === 404){
				message.error("Porfavor, vuelve a iniciar sesion.");
				return false;
			} else {
				printMessages(results);
				return false;
			}
		} catch (error) {
			message.error("Upload failed");
			return false;
		}
		return true;
	};

	const batchSize = 5;
	let newFileList = [...fileList];
	for (let i = 0; i < fileList.length; i += batchSize) {
		const batch = fileList.slice(i, i + batchSize);
		const filesUploadedSuccessfull = await uploadFiles(batch);
		if(filesUploadedSuccessfull) {
			newFileList = newFileList.filter(file => !batch.includes(file));
			setFileList(newFileList);
		}
	}

	setLoading(false);
};

export const UploadInvoices = ({token, companies_of_user}) => {
	const { token : antToken } = theme.useToken();
	const [fileList, setFileList] = useState([]);
	const [loading, setLoading] = useState(false);

	const handleChange = (info) => {
		let files = [...info.fileList];
		setFileList(files);
	};
	
	return (
		<>
			<h1>Uploader de Facturas</h1>
			{companies_of_user.length === 0 && <h2>No tienes compañias asignadas, ingresa tus compañias</h2>}
			{companies_of_user.length > 0 && (
				<div style={{ height: "55%" }}>
					<Dragger
						name="file"
						multiple={true}
						beforeUpload={() => false}
						onChange={handleChange}
						fileList={fileList}
						disabled={loading}
						style={{
							backgroundColor: antToken.colorBgLayout
						}}
					>
						<p className="ant-upload-drag-icon"> <InboxOutlined /> </p>
						<p className="ant-upload-text">Tu Uploader está listo. Agrega tus facturas</p>
						<p className="ant-upload-hint">Puedes subir archivos xml o archivos excel.</p>
					</Dragger>
					<Button
						type="primary"
						onClick={() => handleUpload(token, fileList, setFileList, setLoading)}
						disabled={fileList.length === 0}
						style={{ 
							marginTop: 16,
							width: "100%",
							height: "10%",
							fontSize: "18px",
						}}
						loading={loading}
					>
						Subir Archivos
					</Button>
				</div>
			)}
		</>
	);
};

UploadInvoices.propTypes = {
	token: PropTypes.string.isRequired,
	companies_of_user: PropTypes.array.isRequired,
};
